import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import CopyToClipButton from './CopyToClipButton';

const MarkdownTextPresenter = ({ markdown, consent = false }) => {

  const markdownComponents = {
    h1: ({ children }) => <h1 className="text-2xl font-bold">{children}</h1>,
    h2: ({ children }) => <h2 className="text-xl font-bold">{children}</h2>,
    h3: ({ children }) => <h3 className="text-lg font-bold">{children}</h3>,
    p: ({ children }) => <p className="text-base">{children}</p>,
    ul: ({ children }) => <ul className="list-disc pl-5">{children}</ul>,
    ol: ({ children }) => <ol className="list-decimal pl-5">{children}</ol>,
  };

  const markdownWithConsent = (consent ? '*The client has consented to the use of Aud Scribe during this appointment* \n\n---\n\n' : '') + markdown;

  return (
    
    <div className="relative prose prose-lg max-w-none p-6 bg-gray-100 rounded-lg shadow-md">
      <CopyToClipButton text={markdownWithConsent}/>
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={markdownComponents} >
         {markdownWithConsent}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownTextPresenter;